import React from "react";
import styles from "../constants/index";

export const HEADER_STYLE = {
  fontSize: "24px",
  lineHeight: "26px",
  letterSpacing: "0.01em",
  fontWeight: "bold",
  color: styles.text["800"],
};

export const SUBHEADER_STYLE = {
  ...HEADER_STYLE,
  fontSize: "16px",
  lineHeight: "24px",
};

export const PANELHEADER_STYLE = {
  ...HEADER_STYLE,
  fontSize: "18px",
  lineHeight: "26px",
};

const getFontStyle = (type: string): React.CSSProperties => {
  switch (type) {
    case "subheader":
      return SUBHEADER_STYLE as React.CSSProperties;
    case "panelheader":
      return PANELHEADER_STYLE as React.CSSProperties;
    default:
      return HEADER_STYLE as React.CSSProperties;
  }
};

type TitleProps = {
  /** The inline style object applied to the containing div */
  style?: React.CSSProperties;
  /** Determines the default inline style ("header", "subheader", "panelheader") the Title will use */
  type?: "header" | "subheader" | "panelheader";
  /** The className applied to the containing div, useful for positioning */
  className?: string;
  /** The content displayed */
  children: React.ReactNode | React.ReactNode[];
};

// REVIEW: the use-case here should be covered by a "Typography" component (an atom)
/**
 * The component to use whenever a short, descriptive summary of the upcoming
 * section is needed. Enforces the font-size and font-weight guidelines that
 * should be used throughout the app for titles.
 * @deprecated
 */
const Title = ({ style, className, type = "header", children }: TitleProps) => {
  const fontStyle = getFontStyle(type);

  return (
    <div
      style={{ ...fontStyle, ...style }}
      className={className}
      role="text"
    >
      {children}
    </div>
  );
};

export default Title;
